export const VENUE_DEVICE_LOCATION_KEY = "venue_device_location"
export const VENUE_DEVICE_NAME_KEY = "venue_device_name"
